import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#submitted",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Claim 1: Approved Bill")
  ])
], -1)
const _hoisted_3 = {
  id: "submitted",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-6" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "card mb-5 mb-xl-10" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-primary",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#tranche3",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Tranche-3")
  ])
], -1)
const _hoisted_9 = {
  id: "tranche3",
  class: "collapse show"
}
const _hoisted_10 = { class: "collapse show" }
const _hoisted_11 = { class: "card-body border-top p-4" }
const _hoisted_12 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_13 = { class: "list-group list-group-horizontal-lg row ml-3" }
const _hoisted_14 = {
  class: "d-flex",
  style: {"min-height":"37px","align-items":"center","justify-content":"center"}
}
const _hoisted_15 = ["src"]
const _hoisted_16 = {
  key: 1,
  src: "media\\logos\\logo.png",
  alt: "Logo",
  class: "mr-3 img-fluid",
  style: {"max-height":"30px"}
}
const _hoisted_17 = {
  class: "mt-3 px-1",
  style: {"border-top":"2px solid #1db78d !important"}
}
const _hoisted_18 = { class: "card mb-5 mb-xl-10" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-info",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#tranche2",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Tranche-2")
  ])
], -1)
const _hoisted_20 = {
  id: "tranche2",
  class: "collapse show"
}
const _hoisted_21 = { class: "collapse show" }
const _hoisted_22 = { class: "card-body border-top p-4" }
const _hoisted_23 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_24 = { class: "list-group list-group-horizontal-lg row ml-3" }
const _hoisted_25 = {
  class: "d-flex",
  style: {"min-height":"37px","align-items":"center","justify-content":"center"}
}
const _hoisted_26 = ["src"]
const _hoisted_27 = {
  key: 1,
  src: "media\\logos\\logo.png",
  alt: "Logo",
  class: "mr-3 img-fluid",
  style: {"max-height":"30px"}
}
const _hoisted_28 = {
  class: "mt-3 px-1",
  style: {"border-top":"2px solid #1db78d !important"}
}
const _hoisted_29 = { class: "card mb-5 mb-xl-10" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-secondary",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#tranch1",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-dark m-0" }, "Tranche-1")
  ])
], -1)
const _hoisted_31 = {
  id: "tranch1",
  class: "collapse show"
}
const _hoisted_32 = { class: "collapse show" }
const _hoisted_33 = { class: "card-body border-top p-4" }
const _hoisted_34 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_35 = { class: "list-group list-group-horizontal-lg row ml-3" }
const _hoisted_36 = {
  class: "d-flex",
  style: {"min-height":"37px","align-items":"center","justify-content":"center"}
}
const _hoisted_37 = ["src"]
const _hoisted_38 = {
  key: 1,
  src: "media\\logos\\logo.png",
  alt: "Logo",
  class: "mr-3 img-fluid",
  style: {"max-height":"30px"}
}
const _hoisted_39 = {
  class: "mt-3 px-1",
  style: {"border-top":"2px solid #1db78d !important"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("ul", _hoisted_13, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tranche3entityInfos, (t3bill, index5) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: index5,
                            class: "list-group-item col-md-1 mr-4 mb-4 card rounded px-2",
                            style: {"min-width":"11.2%"}
                          }, [
                            _createElementVNode("div", _hoisted_14, [
                              _createVNode(_component_router_link, {
                                to: {
                                  name: 'claim_1 approved bill list',
                                  params: {
                                    entity_id: t3bill.id,
                                    tranche_id: 5,
                                    entity_short_name: t3bill.entity_short_name,
                                  },
                                },
                                class: "text-black fw-bold fs-6 mt-2"
                              }, {
                                default: _withCtx(() => [
                                  (t3bill.attach_file_info)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        src: 
                                    _ctx.api_url +
                                    t3bill?.attach_file_info?.file_path
                                  ,
                                        alt: "Logo",
                                        class: "mr-3 img-fluid",
                                        style: {"max-height":"30px"}
                                      }, null, 8, _hoisted_15))
                                    : (_openBlock(), _createElementBlock("img", _hoisted_16)),
                                  _createElementVNode("strong", null, _toDisplayString(t3bill.bill_count), 1)
                                ]),
                                _: 2
                              }, 1032, ["to"])
                            ]),
                            _createElementVNode("div", _hoisted_17, [
                              _createVNode(_component_router_link, {
                                to: {
                                  name: 'claim_1 approved bill list',
                                  params: {
                                    entity_id: t3bill.id,
                                    tranche_id: 5,
                                    entity_short_name: t3bill.entity_short_name,
                                  },
                                },
                                class: "text-black fw-bold fs-6 mt-2"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("h4", null, _toDisplayString(t3bill.entity_short_name), 1)
                                ]),
                                _: 2
                              }, 1032, ["to"])
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("ul", _hoisted_24, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tranche2entityInfos, (t2bill, index3) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: index3,
                            class: "list-group-item col-md-1 mr-4 mb-4 card rounded px-2",
                            style: {"min-width":"11.2%"}
                          }, [
                            _createElementVNode("div", _hoisted_25, [
                              _createVNode(_component_router_link, {
                                to: {
                                  name: 'claim_1 approved bill list',
                                  params: {
                                    entity_id: t2bill.id,
                                    tranche_id: 2,
                                    entity_short_name: t2bill.entity_short_name,
                                  },
                                },
                                class: "text-black fw-bold fs-6 mt-2"
                              }, {
                                default: _withCtx(() => [
                                  (t2bill.attach_file_info)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        src: 
                                    _ctx.api_url +
                                    t2bill?.attach_file_info?.file_path
                                  ,
                                        alt: "Logo",
                                        class: "mr-3 img-fluid",
                                        style: {"max-height":"30px"}
                                      }, null, 8, _hoisted_26))
                                    : (_openBlock(), _createElementBlock("img", _hoisted_27)),
                                  _createElementVNode("strong", null, _toDisplayString(t2bill.bill_count), 1)
                                ]),
                                _: 2
                              }, 1032, ["to"])
                            ]),
                            _createElementVNode("div", _hoisted_28, [
                              _createVNode(_component_router_link, {
                                to: {
                                  name: 'claim_1 approved bill list',
                                  params: {
                                    entity_id: t2bill.id,
                                    tranche_id: 2,
                                    entity_short_name: t2bill.entity_short_name,
                                  },
                                },
                                class: "text-black fw-bold fs-6 mt-2"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("h4", null, _toDisplayString(t2bill.entity_short_name), 1)
                                ]),
                                _: 2
                              }, 1032, ["to"])
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _hoisted_30,
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("ul", _hoisted_35, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tranche1entityInfos, (t1bill, index1) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: index1,
                            class: "list-group-item col-md-1 mr-4 mb-4 card rounded px-2",
                            style: {"min-width":"11.2%"}
                          }, [
                            _createElementVNode("div", _hoisted_36, [
                              _createVNode(_component_router_link, {
                                to: {
                                  name: 'claim_1 approved bill list',
                                  params: {
                                    entity_id: t1bill.id,
                                    tranche_id: 1,
                                    entity_short_name: t1bill.entity_short_name,
                                  },
                                },
                                class: "text-black fw-bold fs-6 mt-2"
                              }, {
                                default: _withCtx(() => [
                                  (t1bill.attach_file_info)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        src: 
                                    _ctx.api_url +
                                    t1bill?.attach_file_info?.file_path
                                  ,
                                        alt: "Logo",
                                        class: "mr-3 img-fluid",
                                        style: {"max-height":"30px"}
                                      }, null, 8, _hoisted_37))
                                    : (_openBlock(), _createElementBlock("img", _hoisted_38)),
                                  _createElementVNode("strong", null, _toDisplayString(t1bill.bill_count), 1)
                                ]),
                                _: 2
                              }, 1032, ["to"])
                            ]),
                            _createElementVNode("div", _hoisted_39, [
                              _createVNode(_component_router_link, {
                                to: {
                                  name: 'claim_1 approved bill list',
                                  params: {
                                    entity_id: t1bill.id,
                                    tranche_id: 1,
                                    entity_short_name: t1bill.entity_short_name,
                                  },
                                },
                                class: "text-black fw-bold fs-6 mt-2"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("h4", null, _toDisplayString(t1bill.entity_short_name), 1)
                                ]),
                                _: 2
                              }, 1032, ["to"])
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ])), [
    [_directive_loading, _ctx.load]
  ])
}